import apiCarteira from "api/api-carteira";
import { useApplicationContext } from "contexts/ApplicationContext";
import { useEffect, useState } from "react";

export interface VendeAIDataProps {
  ativo: boolean;
  statusCode:
    | "does_not_exist"
    | "pending_activation"
    | "free_trial"
    | "active"
    | "inactive"
    | "cancelled"
    | string;
  detailsManageSubscriptionLink?: string;
  detailsOnboardingLink?: string;
  statusReason?: string;
  detailsDashboardLink?: string;
}

export function useVendeAi() {
  const [vendeAiInfo, setVendeAiInfo] = useState<Partial<VendeAIDataProps>>({});
  const { user } = useApplicationContext();

  const getVendeAiInfo = async () => {
    try {
      const { data } = await apiCarteira.get(
        `/services?customer_id=${user.userData.customerId}`
      );
      setVendeAiInfo(data.vendeAI);
    } catch (e) {
    } finally {
    }
  };

  useEffect(() => {
    getVendeAiInfo();
  }, []);

  return vendeAiInfo;
}
